export default __webpack_public_path__ + "static/media/player.30113b39.jpg";